import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';

import { DcIcons } from '../../../ui/app-dc.icons';

const HEX_COLOR_PATTERN = /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

const isHexColor = (value: string): boolean => HEX_COLOR_PATTERN.test(value);

export type GroupingTagConfigPopupData = {
	id: string | null;
	label: string;
	color: string;
};

@Component({
	selector: 'app-grouping-tag-config-popup',
	templateUrl: './config-popup.component.html',
	styleUrls: ['./config-popup.component.scss'],
})
export class ConfigPopupComponent<
	T extends GroupingTagConfigPopupData
> extends DcBaseComponent {
	public readonly LABEL_MAX_LEN = 50;
	public tagLabel = '';
	public tagColor = '#008080';
	public readonly colorPattern =
		'#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})';
	public readonly allowedFormats = 'hex';
	public readonly hideColorPicker = false;
	public readonly hideTextInput = false;
	public readonly acceptLabel = $localize`:@@groupingTag.ngx-color.accept:`;
	public readonly cancelLabel = $localize`:@@groupingTag.ngx-color.cancel:`;

	protected readonly DcIcons = DcIcons;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'grouping-tag-config-popup';

		this.tagLabel = this.modalData.label;
		this.tagColor = this.modalData.color;
	}

	public setNewLabel(newVal: string): void {
		this.tagLabel = newVal;
	}

	public setNewColor(newColor: string): void {
		this.tagColor = newColor;
	}

	public get labelRequiredError(): boolean {
		return this.tagLabel.length === 0;
	}

	public get colorRequiredError(): boolean {
		return this.tagColor.length === 0;
	}

	public get colorPatternError(): boolean {
		return this.tagColor.length > 0 && !isHexColor(this.tagColor);
	}

	public onCancel(): void {
		this.modalService.closeActiveModal(undefined);
	}

	public onSave(): void {
		this.modalService.closeActiveModal({
			label: this.tagLabel,
			color: this.tagColor,
		});
	}

	public isValid(): boolean {
		return (
			!this.labelRequiredError &&
			!this.colorRequiredError &&
			!this.colorPatternError
		);
	}
}
